import { Button, CircularProgress } from "@mui/material";

import { useTranslation } from "react-i18next";

import { useDeleteMeasureConfiguration } from "hooks/measureConfigHooks";
import { useNavigate } from "hooks/routerHooks";

interface Props {
  uuid: string;
  measureConfigId: number;
}

export default function DeleteMeasureConfig(props: Props) {
  const { uuid, measureConfigId } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { mutateAsync: deleteMeasureConf, isLoading } =
    useDeleteMeasureConfiguration(uuid);

  async function deleteMeasureConfig() {
    await deleteMeasureConf(measureConfigId, {
      onSuccess: () => {
        navigate(`/${uuid}/measures`);
      },
    });
  }
  return (
    <Button
      color="error"
      variant="contained"
      disabled={isLoading}
      onClick={() => deleteMeasureConfig()}
    >
      {isLoading && <CircularProgress size={20} />}
      {!isLoading && t("label.delete")}
      {isLoading && t("label.loading")}
    </Button>
  );
}
